// Static particle config for the Hero section's ambient float.
// Extracted from Hero.jsx to keep the parent under ~120 lines.
export const HERO_PARTICLES = Array.from({ length: 18 }, (_, i) => ({
  id: `p-${i}`,
  left: `${(i * 53) % 100}%`,
  delay: `${(i * 0.7) % 12}s`,
  duration: `${10 + ((i * 1.3) % 8)}s`,
  size: `${3 + (i % 4)}px`,
}));

export function HeroParticles() {
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
      {HERO_PARTICLES.map((p) => (
        <span
          key={p.id}
          className="particle"
          style={{
            left: p.left,
            animationDelay: p.delay,
            animationDuration: p.duration,
            width: p.size,
            height: p.size,
          }}
        />
      ))}
    </div>
  );
}
